import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return userData ? children : <Navigate to="/" />;
};

export default PrivateRoute;
